import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
// Components
import { Modal } from 'semantic-ui-react'
import { StyledInput } from '..'
// Styles
import {
  StyledModal,
  Container,
  StyledText,
  StyledTextBlue,
  ErrorMsg,
} from './Verification.styles'

const save = 'save'

const EnterEnrollerId = ({ open, onClose, value, onSave }) => {
  const [localValue, setLocalValue] = useState('')

  useEffect(() => {
    setLocalValue(value)

    return () => {
      setLocalValue(value)
    }
  }, [value, open])

  return (
    <StyledModal
      style={{ width: '80%', maxWidth: 300, padding: 8 }}
      closeIcon
      centered={true}
      closeOnDimmerClick={false}
      closeOnEscape={false}
      dimmer="blurring"
      onClose={() => onClose(value, localValue)}
      open={open}
    >
      <Modal.Content>
        <Container direction="column">
          <StyledText>
            If you don't know the ID number of the Ambassador that referred you,
            contact them and ask.
          </StyledText>
          <Container style={{ height: 24, maxWidth: 300 }}>
            {isNaN(localValue) && (
              <ErrorMsg>{'The Id must be a number'}</ErrorMsg>
            )}
          </Container>
          <StyledInput
            value={localValue}
            onChange={e => setLocalValue(e.target.value)}
            placeholder={`Referrer's ID Number`}
          />
          <StyledTextBlue
            onClick={() => onSave(localValue)}
            style={{ alignSelf: 'flex-end' }}
          >
            {save.toUpperCase()}
          </StyledTextBlue>
        </Container>
      </Modal.Content>
    </StyledModal>
  )
}

EnterEnrollerId.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  value: PropTypes.string,
  onSave: PropTypes.func.isRequired,
}

export default EnterEnrollerId
